import styled from "styled-components";
import {FormCheckBoxCompType, FormCheckBoxParams, FormInputViewType} from "./types";

export const FormInput = styled.input.attrs<FormInputViewType>(({isValid, theme}) => {
    return {
        style: {borderColor: isValid ? 'rgba(0, 0, 0, 0.1)' : 'red'}
    }
})<FormInputViewType>`
  background: #F7F4F5;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  width: 100%;
  padding: 1rem;
  font-size: 1rem;
`

export const FormTextArea = styled.textarea.attrs<FormInputViewType>(({isValid, theme}) => {
    return {
        style: {borderColor: isValid ? 'rgba(0, 0, 0, 0.1)' : 'red'}
    }
})<FormInputViewType>`
  background: #F7F4F5;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  width: 100%;
  padding: 1rem;
  font-size: 1rem;
  font-family: ${({theme}) => theme.font.family};
  resize: none;
`

export const FormCheckBox = styled.input.attrs<{}>(() => {

})`
  display: inline-block;
  width: 16px;
  height: 16px;
  background: ${props => props.checked ? 'salmon' : 'papayawhip'};
  border-radius: 3px;
  transition: all 150ms;
`

export const FormCheckboxContainer = styled.div`
  display: inline-block;
  vertical-align: middle;
`

export const FormCheckBoxIcon = styled.svg`
  fill: none;
  stroke: white;
  stroke-width: 2px;
`

export const StyledCheckbox = styled.div<FormCheckBoxCompType>`
  display: inline-block;
  cursor: pointer;
  width: 30px;
  height: 30px;
  padding: 6px 3px 6px 3px;
  background: ${({checked, theme}) => (checked ? theme.colors.red : '#FFFFFF')};
  border-radius: 5px;
  border: 1px solid #00000033;
  /*background: linear-gradient(0deg, #B3376C, #B3376C),
  linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2));
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)),
  linear-gradient(0deg, #FFFFFF, #FFFFFF);*/


  transition: all 150ms;

  ${FormCheckBoxIcon} {
    visibility: ${checked => (checked ? 'visible' : 'hidden')}
  }
`

export const FormInputHint = styled.div`
  text-align: right;
  color: red;
  font-size: .8rem;
`